import type { FunctionComponent } from 'react';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { useFeatureFlagContext } from '@fff-web/feature-flags';
import useScreenMode from '../../../hooks/useScreenMode';
import { appEnv } from '../../../utils/env';
import { DESKTOP, Plans } from '../../constants';
import * as styles from './TrialUpgradeDisclaimer.module.scss';

type TrialUpgradeDisclaimerProps = {
  selected: string;
};

const TrialUpgradeDisclaimer: FunctionComponent<TrialUpgradeDisclaimerProps> = ({ selected }) => {
  const flags = useFeatureFlagContext();
  const screenMode = useScreenMode();
  const disclaimerPriceIncreaseFF = flags?.disclaimerPriceIncrease;
  const getDisclaimerName = () => {
    if (selected === Plans.SEASONAL) {
      if (disclaimerPriceIncreaseFF) {
        return DISCLAIMER_NAMES.activateMembershipSeasonalPriceIncrease;
      }
      return DISCLAIMER_NAMES.activateMembershipSeasonal;
    }
    return DISCLAIMER_NAMES.activateMembershipAnnual;
  };

  const disclaimerName = getDisclaimerName();

  const tudStyles = screenMode !== DESKTOP ? styles.tudContainerMobile : styles.tudContainerDesktop;

  return (
    <div className={tudStyles} data-testid={`${disclaimerName}-disclaimer`}>
      <Disclaimer name={disclaimerName} env={appEnv} />
    </div>
  );
};

export default TrialUpgradeDisclaimer;
